<template>
  <div>
    <HeadNav></HeadNav>
    <Breadcrumb v-show="meetingName" :meetingName="meetingName"></Breadcrumb>
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>
    <FooterNav></FooterNav>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import FooterNav from './FooterNav/index.vue'
import HeadNav from './HeadNav/index.vue'
import Breadcrumb from './Breadcrumb/index.vue'
import { useRoute } from 'vue-router'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  components: {
    FooterNav,
    HeadNav,
    Breadcrumb
  },
  setup() {
    const route: RouteLocationNormalizedLoaded = useRoute()
    const meetingName = computed(() => {
      return (route.query.meetingName as string) || ''
    })
    return {
      meetingName
    }
  }
})
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
